(function() {
  'use strict';
  angular.module('benefits')
  .filter('handleZeroRemaining', ['benefitService', function(benefitService) {
    return function(amount, type) {
      if (type === 'maximum' && amount === '$0.00') {
        return '<span class="text-danger">' + amount + '</span>';
      }
      return amount;
    };
  }]);
})();
